import React, { useEffect } from 'react';
import 'katex/dist/katex.min.css';
import renderMathInElement from "katex/dist/contrib/auto-render.js";
import { applyKatexWrap, flattenKatexUnderlines } from 'global/katexWrap';

import './index.css';

type DragAndDropBucketPreviewProps = {
    question: any;
    showAnswer: boolean;
};

function DragAndDropBucketPreview({ question, showAnswer } : DragAndDropBucketPreviewProps) {

    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        // Wraps unconditionally (the subject test was commented out before this
        // helper existed). Kept as-is; the array guard inside is what matters.
        applyKatexWrap(document, { enabled: true });

        flattenKatexUnderlines(document);

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    useEffect(() => {
        renderKatex();
    }, [showAnswer]);
    return (
        <>
            <div className='digitalSHSATPreview__bucketItems'>
                {question.dragAndDropItems.filter(item => (
                    showAnswer ? !question.answers.find(answer => answer[1] === item.id) : true
                )).map(item => (
                    <div
                        key={item.id}
                        className='katex digitalSHSATPreview__bucketItem'
                    >
                        {item.answer}
                    </div>
                ))}
            </div>
            <div className='digitalSHSATPreview__buckets'>
                {question.buckets.map(bucket => (
                    <div
                        key={bucket.bucketId}
                        className='digitalSHSATPreview__bucket'
                    >
                        <h4 className='katex digitalSHSATPreview__bucketName'>
                            {bucket.name}
                        </h4>
                        {question.dragAndDropItems.filter(item => (
                            showAnswer 
                                ? question.answers.find(answer => answer[0] === bucket.bucketId && answer[1] === item.id)
                                : false
                        )).map(item => (
                            <div
                                key={`${bucket.bucketId}-${item.id}`}
                                className={showAnswer
                                    ? 'katex digitalSHSATPreview__bucketItem--correct'
                                    : 'katex digitalSHSATPreview__bucketItem'
                                }
                            >
                                {item.answer}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
}

export default DragAndDropBucketPreview;